export default "__VITE_ASSET__Ctn$RnPh__"